import { render, staticRenderFns } from "./income-mx.vue?vue&type=template&id=074505b5&"
import script from "./income-mx.vue?vue&type=script&lang=js&"
export * from "./income-mx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports